// eslint-disable-next-line ember/no-classic-components
import Component from '@ember/component';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  tagName: '',
});
